export default {
  // 列表表头
  columns: [
    {
      width: 200,
      align: 'center',
      title: '设备编号',
      dataIndex: 'deviceCode',
    },
    {
      width: 200,
      align: 'center',
      title: '设备名称',
      dataIndex: 'deviceName',
      scopedSlots: { customRender: 'deviceName' }
    },
    {
      width: 200,
      align: 'center',
      title: '设备类型',
      dataIndex: 'deviceCommonId_dictText'
    },
    {
      width: 80,
      align: 'center',
      title: '运行状态',
      dataIndex: 'runningStatus_dictText'
    },
    {
      width: 80,
      align: 'center',
      title: '当前状态',
      dataIndex: 'status_dictText'
    },
    {
      width: 110,
      align: 'center',
      title: '状态变更日期',
      dataIndex: 'recordDate'
    },
    {
      width: 80,
      align: 'center',
      title: '原状态',
      dataIndex: 'oldStatus_dictText'
    },
    {
      width: 150,
      align: 'center',
      title: '品牌',
      dataIndex: 'brand'
    },
    {
      width: 150,
      align: 'center',
      title: '规格',
      dataIndex: 'spec'
    },
    {
      width: 150,
      align: 'center',
      title: '公司',
      dataIndex: 'companyCode_dictText'
    },
    {
      width: 150,
      align: 'center',
      title: '海洋馆',
      ellipsis: true,
      dataIndex: 'aquariumCode_dictText'
    },
    {
      width: 150,
      align: 'center',
      title: '展区',
      ellipsis: true,
      dataIndex: 'venueCode_dictText'
    },
    {
      width: 200,
      align: 'center',
      title: '缸体',
      ellipsis: true,
      dataIndex: 'cylinderCode_dictText'
    },
    {
      width: 150,
      align: 'center',
      title: '备注',
      ellipsis: true,
      dataIndex: 'remarks'
    },
    {
      width: 100,
      align: 'center',
      title: '创建人',
      dataIndex: 'createBy_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '创建时间',
      dataIndex: 'createTime'
    },
    {
      width: 150,
      align: 'center',
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      scopedSlots: { customRender: 'action' }
    }
  ],
  // 详情设备记录列表表头
  detailColumns: [
    {
      width: 100,
      align: 'center',
      title: '业务日期',
      dataIndex: 'recordDate',
    },
    {
      width: 100,
      align: 'center',
      title: '操作类型',
      dataIndex: 'operaType_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '运行状态',
      dataIndex: 'runningStatus_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '现状态',
      dataIndex: 'status_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '原状态',
      dataIndex: 'oldStatus_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '方式',
      dataIndex: 'mode_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '处理方式',
      dataIndex: 'modeDesc'
    },
    {
      width: 120,
      align: 'center',
      title: '原因',
      dataIndex: 'reason_dictText'
    },
    {
      width: 120,
      align: 'center',
      title: '原因描述',
      dataIndex: 'reasonDesc'
    },
    {
      width: 150,
      align: 'center',
      title: '公司',
      dataIndex: 'companyCode_dictText'
    },
    {
      width: 150,
      align: 'center',
      title: '海洋馆',
      ellipsis: true,
      dataIndex: 'aquariumCode_dictText'
    },
    {
      width: 150,
      align: 'center',
      title: '展区',
      ellipsis: true,
      dataIndex: 'venueCode_dictText'
    },
    {
      width: 200,
      align: 'center',
      title: '缸体',
      ellipsis: true,
      dataIndex: 'cylinderCode_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '操作人',
      dataIndex: 'createBy_dictText'
    },
    {
      width: 100,
      align: 'center',
      title: '操作时间',
      dataIndex: 'createTime'
    },
  ],
  // 树节点类型对应查询参数字段
  nodeTypeField: {
    // 公司
    '1': 'companyCode',
    // 展区
    '2': 'aquariumCode',
    // 场馆
    '3': 'venueCode',
    // 缸体
    '4': 'cylinderCode'
  },
  // 操作类型
  actionType: {
    '0': '新增',
    '1': '设备禁用',
    '2': '设备更换',
    '3': '设备移除',
    '4': '设备启用',
    '5': '编辑',
  },
  // 设备运行状态
  deviceStatus: {
    // 运行
    run: '10',
    // 停运
    off: '20',
    // 移除
    remove: '30',
  },
}

